export const styles = {
	icon: {
		fontSize: '68px',
		margin: '8px',
		color: 'secondary.main'
	},
	large: {
		width: 8,
		height: 8
	},
	BtnUpdate: {
		color: '#212121',
		backgroundColor: '#8098b2'
	},
	spacer: {
		margin: '8px'
	}
};
